import React, { ReactNode } from 'react';
import { CarouselV2 } from '../carousel-v2';

type CategoriesCarouselProps = {
  children: ReactNode;
  title: string;
};

export const CategoriesCarousel = ({ children, title }: CategoriesCarouselProps): JSX.Element => (
  <CarouselV2 title={title}>{children}</CarouselV2>
);
